import { createFileRoute } from '@tanstack/react-router';
import {
  createPermissionGuard,
  getPermissionSet,
  GROUP_MANAGEMENT_PERMISSIONS,
} from '@bmwe/ui';
import { Groups } from '../../../features/management/groups/groups';

export const Route = createFileRoute('/verwaltung/gruppen/')({
  component: Groups,
  beforeLoad: createPermissionGuard(
    getPermissionSet(GROUP_MANAGEMENT_PERMISSIONS, 'EDIT'),
  ),
});

export const ListGroupsRoute = Route;
